<template>
    <modal name="update_promocode" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update promocode')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <promocode-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import PromocodeService from '@services/promocode.service';
import PromocodeForm from './components/Form';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                code: null,
                discount_percent: null,
                start_date: null,
                end_date: null
            },
            loading: false,
            promocode_id: null
        };
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    PromocodeService.update(this.promocode_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setPromocode', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const promocode = event.params.promocode;
            if (promocode) {
                this.form.code = promocode.code;
                this.form.discount_percent = promocode.discount_percent;
                this.form.start_date = moment(promocode.start_date).format('L');
                this.form.end_date = moment(promocode.end_date).format('L');
                this.promocode_id = promocode.id;
            }
        },
        hide() {
            this.$modal.hide('update_promocode');
        }
    },
    components: {
        PromocodeForm
    }
};
</script>
